import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    CardBody,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
    Table
} from 'reactstrap';
import Select from 'react-select';

import { C_Select, CInput, decimalRegx_3dit } from '../../../CustomValidateForm';
import { Breadcrumb_inputName, commonPageField, commonPageFieldSuccess, get_Category_By_CategoryType_ForDropDownAPI, get_CategoryTypes_ForDropDown, get_Group_By_GroupType_ForDropDown, get_Sub_Group_By_Group_ForDropDown, get_Sub_Group_By_Group_ForDropDown_Success, getBaseUnit_ForDropDown, getCategoryTypelist, saveItemMasterAction, SaveItemMasterActionSuccess, savePartyItemsAction } from '../../../store/actions';
import { comAddPageFieldFunc, formValid, initialFiledFunc, onChangeSelect, onChangeText, } from '../../../components/Common/validationFunction';
import { breadcrumbReturnFunc, btnIsDissablefunc, currentDate_ymd, getSettingBasedPartyTypeID, loginCompanyID, loginRoleID, loginSystemSetting, loginUserID, metaTagLabel } from '../../../components/Common/CommonFunction';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { MetaTags } from 'react-meta-tags';
import { mode, pageId, url } from '../../../routes';
import { unitConversionInitial } from './ItemMaster/itemIndex';
import { GeneralMasterSubType } from '../../../store/Administrator/GeneralRedux/action';
import { priceListByPartyAction } from '../../../store/Administrator/PriceList/action';
import { getPartyListAPI } from '../../../store/Administrator/PartyRedux/action';
import { getPartyTypelist } from '../../../store/Administrator/PartyTypeRedux/action';

import { getGroupTypeslist } from '../../../store/Administrator/GroupTypeRedux/action';
import { Tbody, Thead } from 'react-super-responsive-table';
import { SaveButton } from '../../../components/Common/CommonButton';
import { saveMsgUseEffect } from '../../../components/Common/CommonUseEffect';
import { PartiesOnPartyType_API } from '../../../helpers/backend_helper';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as _cfunc from "../../../components/Common/CommonFunction";
import { customAlert } from '../../../CustomAlert/ConfirmDialog';



const ItemMasterForm = (props) => {
    const dispatch = useDispatch();
    const history = useHistory()
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty("editValue")
    const systemSetting = _cfunc.loginSystemSetting();

    const maxGST = Number(systemSetting?.MAX_GST_PERCENT);

    const fileds = {
        HSNCode: "",
        GST: "",
        MRP: "",
        Name: "",
        ShortName: "",
        ShelfLife: "",
        Itemcode: "",
        BaseUnitName: "",
        SAPItemCode: null,
        BarCode: '',
        Category: [{ "value": 1, "label": "Finished Product" }],
        CategoryType: { "value": 1, "label": "Finished Product" },
        BrandName: [],
        Division: [],
        Tag: '',
        Sequence: '',
        IsCBMItem: true,
        isActive: true,
        IsSCM: false,
        IsMixItem: false,
        IsLiveRateAllow: false,
        settable: [],
        BaseUnit: [],
        PartyType: [], // Default value for PartyType
        GroupType: { value: null, label: "Select" },
        SubGroup: { value: null, label: "Select" },
        Group: { value: null, label: "Select" },
        ItemShelfLife: [],
        Party: { value: null, label: "All" },

    }

    const [userPageAccessState, setUserAccState] = useState('');
    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [baseUnit, setBaseUnit] = useState([]);
    // modal open state
    const [partyModalOpen, setPartyModalOpen] = useState(false);
    // selected parties as array of { value, label }
    const [selectedParties, setSelectedParties] = useState([]);
    const [partyGroupState, setPartyGroupState] = useState([]);
    const [searchParty, setSearchParty] = useState("");
    const [showUnitTable, setShowUnitTable] = useState(false);



    const { values } = state;
    const { isError } = state;
    const { fieldLabel } = state;

    const {
        postMsg,
        CategoryTypeList,
        pageField,
        BaseUnit,
        userAccess,
        CategoryList,
        PartyTypes,
        GroupType, GroupList, SubGroupList, groupDropDownLoading, subgroupDropDownLoading, saveBtnloading,
    } = useSelector((state) => ({
        PartyTypes: state.PartyTypeReducer.ListData,
        BaseUnit: state.ItemMastersReducer.BaseUnit,
        CategoryList: state.ItemMastersReducer.Category,
        CategoryTypeList: state.categoryTypeReducer.categoryTypeListData,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        postMsg: state.ItemMastersReducer.postMsg,

        saveBtnloading: state.ItemMastersReducer.saveBtnloading,
        GroupType: state.GroupTypeReducer.GroupType,
        GroupList: state.ItemMastersReducer.GroupList,
        SubGroupList: state.ItemMastersReducer.SubGroupList,
        groupDropDownLoading: state.ItemMastersReducer.groupDropDownLoading,
        subgroupDropDownLoading: state.ItemMastersReducer.subgroupDropDownLoading,

    }));


    useEffect(() => {

        dispatch(getCategoryTypelist({ CompanyID: loginCompanyID() }));//Category tab
        dispatch(get_CategoryTypes_ForDropDown());
        dispatch(getPartyListAPI());
        dispatch(getBaseUnit_ForDropDown());

        dispatch(getGroupTypeslist());//group Tab

        const jsonBody = JSON.stringify({
            Company: loginCompanyID(),
            TypeID: 1
        });
        dispatch(GeneralMasterSubType(jsonBody));

    }, []);



    // toggle a party in selection (multiselect)
    const togglePartySelection = (party) => {
        setSelectedParties(prev => {
            const exists = prev.find(p => p.value === party.value);
            if (exists) return prev.filter(p => p.value !== party.value);
            return [...prev, party];
        });
    };

    // when opening modal, initialize from current values or empty
    const openPartyModal = () => {
        // if values.Party.label indicates number selected, prefer selectedParties state
        // otherwise initialize from values.Party if single selection exists
        if (selectedParties.length === 0 && values.Party && values.Party.value) {
            setSelectedParties([{ value: values.Party.value, label: values.Party.label }]);
        }
        setPartyModalOpen(true);
    };





    useEffect(() => {
        let mounted = true;

        const fetchPartiesForMultipleTypes = async () => {
            try {
                const selectedTypes = values.PartyType;

                setSelectedParties([]);

                if (!Array.isArray(selectedTypes) || selectedTypes.length === 0) {
                    if (mounted) {
                        setPartyGroupState([]);
                    }
                    return;
                }

                let groupArray = [];

                // LOOP through each party type
                for (let pt of selectedTypes) {
                    const resp = await PartiesOnPartyType_API(pt.value);

                    if (resp?.StatusCode === 200 && Array.isArray(resp.Data)) {
                        groupArray.push({
                            partyTypeName: pt.label,
                            partyTypeId: pt.value,
                            parties: resp.Data
                        });
                    }
                }

                if (mounted) {
                    setPartyGroupState(groupArray);
                }

            } catch (err) {
                console.error("Party fetch error", err);
                if (mounted) setPartyGroupState([]);
            }
        };

        fetchPartiesForMultipleTypes();

        return () => { mounted = false; };

    }, [values.PartyType]);




    useEffect(() => saveMsgUseEffect({
        postMsg,
        history,
        dispatch,
        postSuccss: SaveItemMasterActionSuccess,
        resetFunc: { fileds, state, setState },
        listPath: url.ITEM_lIST
    }), [postMsg]);




    useEffect(() => {
        if (!(postMsg && postMsg.Status === true && postMsg.StatusCode === 200)) return;

        try {
            const newItemId = postMsg?.TransactionID;
            if (!newItemId) return;

            // selected parties → CSV
            const parties = (selectedParties && selectedParties.length)
                ? selectedParties.map(p => p.value)
                : [];

            if (!parties.length) return;

            const partyCsv = parties.join(",");

            // MULTI PARTY TYPE → CSV
            let partyTypeCsv = "";

            if (Array.isArray(values.PartyType)) {
                partyTypeCsv = values.PartyType.map(pt => pt.value).join(",");
            } else if (values.PartyType?.value) {
                partyTypeCsv = values.PartyType.value.toString();
            }

            // final payload
            const payload = {
                Item: Number(newItemId),
                MiniItemMaster: true,
                PartyType: partyTypeCsv,     // MULTI CSV
                AsginParties: partyCsv       // MULTI CSV
            };

            dispatch(
                savePartyItemsAction({
                    jsonBody: JSON.stringify(payload),
                    subPageMode: url.CHANNEL_ITEM
                })
            );

            setSelectedParties([]);
            setState(prev => ({
                ...prev,
                values: { ...prev.values, Party: { value: null, label: "" } }
            }));

        } catch (e) {
            console.error("channel bind error", e);
        }
    }, [postMsg]);




    // --------------------------------------------------------------------------




    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };

        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        const page_Id = pageId.MINI_ITEM_MASTER;
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))
    }, []);

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    // ********************************************************* Base Unit Dropdown Options  **********************************


    function BaseUnitOnchange(hasSelect, evn) {
        onChangeSelect({ hasSelect, evn, state, setState });

        const additionalUnits = [];

        if (hasSelect.value !== 1) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 1, label: 'No' }, Conversion: 1, IsBase: false, id: 2, IsShowUnit: true });
        }
        if (hasSelect.value !== 2) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 2, label: 'Kg' }, Conversion: 1, IsBase: false, id: 3, IsShowUnit: true });
        }
        if (hasSelect.value !== 4) {
            additionalUnits.push({ ...unitConversionInitial, Unit: { value: 4, label: 'Box' }, Conversion: 1, IsBase: false, id: 4, IsShowUnit: true });
        }

        if (state.values.BaseUnitName?.value !== hasSelect.value) {

            const baseRow = {
                ...unitConversionInitial,
                IsBase: true,
                Conversion: 1,
                Unit: hasSelect,
                id: 1,
                IsShowUnit: true,

                POUnit: true,   // first row → PO selected
                SOUnit: true,   // first row → SO selected
            };

            const newRows = [baseRow, ...additionalUnits];
            setBaseUnit(newRows);
        }


    }


    const BaseUnit_DropdownOptions = BaseUnit.map((data) => ({
        value: data.id,
        label: data.Name
    }));


    // ***********************************************************Category Type Dropdown Options*********************************

    const CategoryTypeList_DropdownOptions = CategoryTypeList.map((data) => ({
        value: data.id,
        label: data.Name,
    }));

    const CategoryList_DropdownOptions = CategoryList.map((data) => ({
        value: data.id,
        label: data.Name,
    }));

    //*****************************************/ partyType Dropdown Options *************************************************

    useEffect(() => {
        dispatch(getPartyTypelist());
    }, []);

    useEffect(() => {
        if (PartyTypes.length === 1) {

            setState((i) => {
                let a = { ...i }
                a.values.PartyType = {
                    value: PartyTypes[0].id,
                    label: PartyTypes[0].Name
                }
                a.hasValid.valid = true;
                return a
            })
            dispatch(priceListByPartyAction(PartyTypes[0].id))
        }
    }, [PartyTypes])


    useEffect(() => {

        const PartyTypeID = getSettingBasedPartyTypeID(loginSystemSetting().PriceListSetting, loginRoleID())
        let PartyType = null
        if (PartyTypeID !== null) {
            PartyType = PartyTypes.find(i => (i.id === PartyTypeID))
        } else {
            PartyType = PartyTypes.find(i => (i.IsRetailer))
        }


    }, [PartyTypes, pageField])

    const PartyTypeDropdown_Options = PartyTypes.map((index) => ({
        value: index.id,
        label: index.Name,
        division: index.IsDivision,
        IsRetailer: index.IsRetailer
    }));




    //********************************************** Group dropdwon***************************************/

    const GroupType_DropdownOptions = GroupType.map((index) => ({
        value: index.id,
        label: index.Name,
        IsReserved: index.IsReserved
    }));

    const Group_DropdownOptions = GroupList.map((index) => ({
        value: index.id,
        label: index.Name,
    }));

    const SubGroup_DropdownOptions = SubGroupList.map((index) => ({
        value: index.id,
        label: index.Name,
    }));

    useEffect(() => {
        if (GroupType && GroupType.length > 0 && state.values.GroupType.value === null) {

            const posItem = GroupType.find(i => i.IsPos === true);

            if (posItem) {
                setState(prev => {
                    let a = { ...prev };
                    a.values.GroupType = {
                        value: posItem.id,
                        label: posItem.Name
                    };
                    a.hasValid.GroupType.valid = true;
                    return a;
                });

                dispatch(get_Group_By_GroupType_ForDropDown(posItem.id));
                dispatch(get_Sub_Group_By_Group_ForDropDown_Success([]));
            }
        }
    }, [GroupType]);


    const GroupType_Handler = (hasSelect, evn,) => {

        onChangeSelect({ hasSelect, evn, state, setState })

        dispatch(get_Group_By_GroupType_ForDropDown(hasSelect.value));
        dispatch(get_Sub_Group_By_Group_ForDropDown_Success([]));



    };

    const Group_Handler = (hasSelect, evn,) => {
        onChangeSelect({ hasSelect, evn, state, setState })
        dispatch(get_Sub_Group_By_Group_ForDropDown(hasSelect.value))
        dispatch(get_Sub_Group_By_Group_ForDropDown_Success([]));


    };

    function CategoryType_Handler(hasSelect, evn,) {
        onChangeSelect({ hasSelect, evn, state, setState })
        dispatch(get_Category_By_CategoryType_ForDropDownAPI(hasSelect.value))

        setState((i) => {
            const a = { ...i }
            a.values.Category = [];
            a.hasValid.Category.valid = false
            return { ...a }
        })
    }


    //********************************************** table  ***************************************/




    function deleteRow_Handler(Id) {
        setBaseUnit(prev => prev.filter(row => row.id !== Id));
    }



    function addRow_Handler() {
        const lastRow = baseUnit[baseUnit.length - 1];
        const newId = lastRow?.id + 1 || 1;

        const newRow = {
            ...unitConversionInitial,

            id: newId,
            isNew: true,  // <-- identify manually added rows
            IsShowUnit: true,
        };

        setBaseUnit((prev) => [...prev, newRow]);
    }

    function handleUnitChange(selectedOption, index) {
        const updated = [...baseUnit];
        updated[index].Unit = selectedOption;
        setBaseUnit(updated);
    }

    // **********************************************************************  ShowUnit_onChange  ****************************************

    function ShowUnit_onChange(checked, index) {
        setBaseUnit((prev) =>
            prev.map((row, i) =>
                i === index ? { ...row, IsShowUnit: checked } : row
            )
        );
    }


    // **********************************************************************  baseUnit2_onChange  ****************************************
    function baseUnit2_onChange(type, index) {
        setBaseUnit(prevTableData =>
            prevTableData.map((row, i) => {

                if (i === index) {
                    return {
                        ...row,
                        IsShowUnit: true,
                        [type]: true
                    };
                } else {

                    return {
                        ...row,
                        [type]: false
                    };
                }
            })
        );
    }

    function handleConversionChange(e, index) {
        const { value } = e.target;
        setBaseUnit(prev =>
            prev.map((row, i) => {
                if (i === index) {
                    return {
                        ...row,
                        Conversion: value
                    };
                }
                return row;
            })
        );
    }



    const SaveHandler = (event) => {

        event.preventDefault();
        const btnId = event.target.id;
        btnIsDissablefunc({ btnId, state: true });

        try {
            if (formValid(state, setState)) {

                if (!isNaN(maxGST) && Number(values.GST) >= maxGST) {

                    btnIsDissablefunc({ btnId, state: false });

                    customAlert({
                        Type: 3, //  Error
                        Message: `GST percentage must be less than ${maxGST}`
                    });

                    return;
                }



                const payload = {
                    Name: values.Name,
                    BarCode: values.BarCode,
                    BaseUnitID: values.BaseUnitName?.value,
                    ShelfLife: values.ShelfLife,
                    ItemCode: values.Itemcode,
                    MRP: values.MRP,
                    HSNCode: values.HSNCode,
                    GST: values.GST,
                    ShortName: values.Name,
                    SAPItemCode: null,
                    IsCBMItem: true,
                    isActive: true,
                    IsSCM: false,
                    IsMixItem: false,
                    IsLiveRateAllow: false,
                    Company: loginCompanyID(),
                    BrandName: "",
                    Tag: "",
                    Sequence: "",
                    CreatedBy: loginUserID(),
                    UpdatedBy: loginUserID(),
                    Breadth: "",
                    Grammage: "",
                    Height: "",
                    Length: "",
                    StoringCondition: values.StoringCondition || "",
                    ItemCategoryDetails: values.Category.map((index) => ({
                        CategoryType: values.CategoryType.value,
                        Category: index.value
                    })),
                    ItemUnitDetails: [
                        ...baseUnit.map((row, index) => {
                            return {
                                id: row.id,
                                BaseUnitQuantity: row.Conversion,
                                UnitID: row.Unit.value,
                                IsBase: row.IsBase,
                                SODefaultUnit: row.SOUnit,
                                PODefaultUnit: row.POUnit,
                                IsShowUnit: row.IsShowUnit,
                            };
                        })
                    ],

                    ItemImagesDetails: [],
                    ItemMRPDetails: [
                        {
                            Division: "",
                            DivisionName: "",
                            PartyName: "",
                            Party: "",
                            EffectiveDate: currentDate_ymd,
                            MRP: values.MRP,
                            PartyType: null,
                            Party: null,
                            PartyTypeName: "",
                            CreatedBy: loginUserID(),
                            UpdatedBy: loginUserID(),
                            Company: loginCompanyID(),
                            IsDeleted: 0,
                            CommonID: 0,
                            IsAdd: true,
                            id: 1
                        }
                    ],
                    ItemMarginDetails: [],
                    ItemGSTHSNDetails: [
                        {
                            CommonID: 0,
                            Company: loginCompanyID(),
                            CreatedBy: loginUserID(),
                            EffectiveDate: currentDate_ymd,
                            GSTPercentage: values.GST,
                            HSNCode: values.HSNCode,
                            id: null,
                            IsAdd: true,
                            IsDeleted: 0,
                            UpdatedBy: loginUserID(),
                        }],
                    ItemGroupDetails: [
                        {
                            Group: values.Group.value,
                            GroupName: values.Group.label,
                            GroupType: values.GroupType.value,
                            GroupTypeName: values.GroupType.label,
                            id: 1,
                            SubGroup: values.SubGroup.value,
                            SubGroupName: values.SubGroup.label,
                        }
                    ],
                    ItemShelfLife: [
                        {
                            Days: values.ShelfLife,
                            CreatedBy: loginUserID(),
                            UpdatedBy: loginUserID(),
                            IsAdd: true
                        }
                    ],

                    ItemDivisionDetails: values.Division?.map(i => ({
                        Party: i.value
                    })) || []
                };

                const jsonBody = JSON.stringify(payload);

                dispatch(saveItemMasterAction({ jsonBody, btnId }));
            }
        } catch (e) {
            console.error("SaveHandler Error:", e);
            btnIsDissablefunc({ btnId, state: false });
        }
    };






    // **********************************************************************  tbodyfunction  ****************************************
    const tbodyfunction = () => {

        return baseUnit.map((row, index, key) => (

            <tr key={row.id}>
                <td>
                    <Row>
                        <Label className="col-sm-2 col-form-label">1</Label>
                        <Col md={7}>
                            <Select
                                isDisabled={!row.isNew} // only enable for new rows
                                placeholder="Select..."
                                value={row.Unit}
                                options={BaseUnit_DropdownOptions}
                                onChange={(selectedOption) => handleUnitChange(selectedOption, index)} // new function to handle manual change
                            />

                        </Col>
                    </Row>
                </td>
                <td>
                    <Row>
                        <Col>
                            <CInput
                                type="text"
                                placeholder="Enter conversion"
                                id={`txtConversion${index}`}
                                cpattern={decimalRegx_3dit}
                                autoComplete="off"
                                value={row.Conversion}
                                onChange={(e) => handleConversionChange(e, index)}
                            />
                        </Col>
                    </Row>
                </td>
                <td>

                    <Input
                        type="radio"
                        checked={row.POUnit}
                        onChange={() => baseUnit2_onChange("POUnit", index)}
                    />
                </td>

                <td>
                    <Input
                        type="radio"
                        checked={row.SOUnit}
                        onChange={() => baseUnit2_onChange("SOUnit", index)}
                    />
                </td>


                <td>
                    <Input
                        type="checkbox"
                        defaultChecked={row.IsShowUnit}
                        disabled={row.POUnit || row.SOUnit}  //  disable if PO or SO selected

                        onChange={(e) => ShowUnit_onChange(e.target.checked, index)}
                    />
                </td>

                <td style={{ minWidth: "80px" }}>

                    <Row>
                        <Col md={6} className='mt-2'>

                            {row.isNew === true && (
                                <i
                                    className="mdi mdi-trash-can text-danger font-size-20 lg-1 "
                                    style={{ cursor: "pointer", marginTop: "25px" }}
                                    onClick={() => deleteRow_Handler(row.id)}
                                />
                            )}
                        </Col>
                        <Col md={6}>

                            {index === baseUnit.length - 1 && (
                                <Button
                                    className="button_add"
                                    color="btn btn-outline-primary border-2 font-size-12"
                                    type="button"
                                    onClick={() => addRow_Handler()}
                                >
                                    <i className="dripicons-plus"></i>
                                </Button>
                            )}
                        </Col>

                    </Row>

                </td>

            </tr>
        ));
    };

    // ********************************************************************************************************

    useEffect(() => {
        setState(prev => ({
            ...prev,
            values: {
                ...prev.values,
                Party: (selectedParties && selectedParties.length > 0)
                    ? { value: null, label: `${selectedParties.length} selected` }
                    : { value: null, label: "All" }
            }
        }));
    }, [selectedParties]);



    return (
        <div className="page-content" >
            <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
            <Card>
                <CardBody>
                    <Row>
                        <Row className="d-flex align-items-start">
                            {/* LEFT SIDE */}
                            <Col md={6} className="d-flex flex-column">
                                <Card className="c_card_body p-3 h-100" style={{ flex: 1, height: '100%' }}>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.Name} </Label>

                                                <Input
                                                    type="text"
                                                    name="Name"
                                                    className="mb-1"
                                                    placeholder="Enter item name"
                                                    value={values.Name}
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })
                                                        dispatch(Breadcrumb_inputName(event.target.value))
                                                    }}
                                                />
                                                {isError.Name.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.Name}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.BarCode} </Label>
                                                <Input
                                                    type="text"
                                                    name="BarCode"
                                                    className="mb-1"
                                                    placeholder="Enter barcode"
                                                    value={values.BarCode}
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })

                                                    }}

                                                />
                                                {isError.BarCode.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.BarCode}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.Itemcode} </Label>
                                                <Input
                                                    type="text"
                                                    name="Itemcode"
                                                    className="mb-1"
                                                    placeholder="Enter Item code"
                                                    value={values.Itemcode}
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })

                                                    }}
                                                />
                                                {isError.Itemcode.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.Itemcode}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.CategoryType} </Label>
                                                <Select
                                                    name="CategoryType"
                                                    value={values.CategoryType}
                                                    isSearchable
                                                    className="react-dropdown"
                                                    classNamePrefix="dropdown"
                                                    options={CategoryTypeList_DropdownOptions}
                                                    onChange={CategoryType_Handler}
                                                />
                                                {isError.CategoryType.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.CategoryType}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>


                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.Category} </Label>
                                                <Select
                                                    name="Category"
                                                    value={values.Category}
                                                    isMulti={true}
                                                    isSearchable
                                                    className="react-dropdown"
                                                    classNamePrefix="dropdown"
                                                    options={CategoryList_DropdownOptions}
                                                    onChange={(hasSelect, evn) => onChangeSelect({ hasSelect, evn, state, setState, })}
                                                />
                                                {isError.Category.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.Category}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01">{fieldLabel.ShelfLife}</Label>
                                                <Input
                                                    type="text"
                                                    name="ShelfLife"
                                                    className="mb-1"
                                                    placeholder="Enter Shelf Life"
                                                    value={values.ShelfLife}
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })
                                                    }}
                                                />
                                                  {isError.ShelfLife.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.ShelfLife}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Card>
                                <Card className="c_card_body p-3">
                                    <Row className="align-items-end">
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01">Channel Type</Label>
                                                <Select
                                                    name="PartyType"
                                                    value={values.PartyType}
                                                    isSearchable
                                                    isMulti={true}
                                                    options={PartyTypeDropdown_Options}
                                                    className="react-dropdown"
                                                    classNamePrefix="dropdown"
                                                    styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                                    onChange={(hasSelect, evn) => onChangeSelect({ hasSelect, evn, state, setState, })}
                                                />
                                                {isError.PartyType.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.PartyType}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label>{fieldLabel.party} </Label>

                                                <div
                                                    onClick={openPartyModal}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "blue",
                                                        fontWeight: "500",
                                                        textDecoration: "underline",
                                                        marginBottom: "10px"
                                                    }}
                                                >
                                                    Party Item Assign
                                                </div>


                                                {isError.Party.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.Party}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>




                                    </Row>



                                </Card>

                                <Card className="c_card_body p-3">
                                    <Row className="align-items-end">
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.GST} </Label>
                                                <Input
                                                    name="GST"
                                                    type="text"
                                                    id="txtGST0"
                                                    value={values.GST}
                                                    placeholder="Please Enter GST"
                                                    autoComplete="off"
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })

                                                    }}
                                                />
                                                {isError.GST.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.GST}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.HSNCode} </Label>
                                                <Input
                                                    type="HSNCode"
                                                    name="HSNCode"
                                                    id="txtHSNCode0"
                                                    value={values.HSNCode}
                                                    placeholder="Please Enter HSNCode"
                                                    autoComplete="off"
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })

                                                    }}
                                                />
                                                {isError.HSNCode.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.HSNCode}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup className='mt-2'>
                                                <Label htmlFor="validationCustom01"> {fieldLabel.MRP} </Label>
                                                <Input
                                                    name="MRP"
                                                    type="text"
                                                    id="txtMRP0"
                                                    value={values.MRP}
                                                    placeholder="Please Enter MRP"
                                                    onChange={(event) => {
                                                        onChangeText({ event, state, setState })

                                                    }}
                                                />
                                                {isError.MRP.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.MRP}</small>
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            {/* RIGHT SIDE */}
                            <Col md={6} className="d-flex flex-column">


                                <Row className="">

                                    <Card className="c_card_body p-3">


                                        <Row className="align-items-end">
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01"> {fieldLabel.GroupType} </Label>
                                                    <Select
                                                        name="GroupType"
                                                        value={values.GroupType}
                                                        options={GroupType_DropdownOptions}

                                                        onChange={GroupType_Handler}
                                                        styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                                    />
                                                    {isError.GroupType.length > 0 && (
                                                        <span className="text-danger f-8">
                                                            <small>{isError.GroupType}</small>
                                                        </span>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01"> {fieldLabel.Group} </Label>
                                                    <C_Select
                                                        name="Group"
                                                        value={values.Group}
                                                        options={Group_DropdownOptions}
                                                        onChange={Group_Handler}
                                                        isLoading={groupDropDownLoading}
                                                        styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                                    />
                                                    {isError.Group.length > 0 && (
                                                        <span className="text-danger f-8">
                                                            <small>{isError.Group}</small>
                                                        </span>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label htmlFor="validationCustom01"> {fieldLabel.SubGroup} </Label>
                                                    <C_Select
                                                        name="SubGroup"
                                                        value={values.SubGroup}
                                                        options={SubGroup_DropdownOptions}
                                                        isLoading={subgroupDropDownLoading}
                                                        onChange={(hasSelect, evn) => onChangeSelect({ hasSelect, evn, state, setState, })}
                                                        styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                                    />
                                                    {isError.SubGroup.length > 0 && (
                                                        <span className="text-danger f-8">
                                                            <small>{isError.SubGroup}</small>
                                                        </span>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Card>

                                    <Card className="c_card_body p-3">
                                        <Col md={6}>
                                            <FormGroup className='m-2'>


                                                {/* 🔵 LABEL + LINK */}
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <Label htmlFor="validationCustom01"> {fieldLabel.BaseUnitName} </Label>

                                                    <button
                                                        type="button"
                                                        onClick={() => setShowUnitTable(prev => !prev)}
                                                        style={{

                                                            color: "blue",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            padding: "3px 10px",
                                                            fontSize: "12px",
                                                            fontWeight: "600",
                                                            cursor: "pointer",
                                                            marginBottom: "10px",
                                                            textDecoration: "underline",

                                                        }}
                                                    >
                                                        {showUnitTable ? "Hide Unit Table" : "Base Unit Table"}

                                                        {/* Arrow Icon */}
                                                        <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                                                            {showUnitTable ? "▲" : "▼"}
                                                        </span>
                                                    </button>

                                                </div>

                                                {/* 🔵 DROPDOWN */}
                                                <Select
                                                    name="BaseUnitName"
                                                    value={values.BaseUnitName}
                                                    isSearchable
                                                    className="react-dropdown"
                                                    classNamePrefix="dropdown"
                                                    options={BaseUnit_DropdownOptions}
                                                    onChange={BaseUnitOnchange}
                                                    styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                                                />

                                                {isError.BaseUnitName.length > 0 && (
                                                    <span className="text-danger f-8">
                                                        <small>{isError.BaseUnitName}</small>
                                                    </span>
                                                )}

                                            </FormGroup>

                                        </Col>
                                        {showUnitTable && (
                                            <div className="mt-2" style={{ overflowX: 'auto' }}>
                                                <Table className="table table-bordered mb-0">
                                                    <Thead>
                                                        <tr>
                                                            <th className="col-sm-3">Unit Name</th>
                                                            <th className="col-sm-3 text-center">Conversion To Base Unit</th>
                                                            <th className="col-sm-1 text-center">PO Unit</th>
                                                            <th className="col-sm-1 text-center">SO Unit</th>
                                                            <th className="col-sm-1 text-center" style={{ width: "70px" }}>
                                                                Show Unit
                                                            </th>
                                                            <th className="col-sm-2">Action</th>
                                                        </tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {baseUnit.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="6">
                                                                    <div className="text-danger text-center">Unit Not available</div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            tbodyfunction()
                                                        )}
                                                    </Tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </Card>


                                </Row>


                            </Col>
                        </Row>

                        {/* GST SECTION */}

                        <SaveButton
                            loading={saveBtnloading}
                            pageMode={mode.defaultsave}
                            onClick={SaveHandler}
                            userAcc={userPageAccessState}

                            module={"Item"}
                        />

                    </Row>
                </CardBody>

            </Card >
            <Modal isOpen={partyModalOpen} toggle={() => setPartyModalOpen(false)} size="md">
                <ModalHeader toggle={() => setPartyModalOpen(false)}> Party Item Assign</ModalHeader>

                {/* 🔍 Search Box BELOW HEADER */}
                <div style={{ position: "relative", width: "250px", marginLeft: "20px" }}>
                    <i
                        className="fa fa-search"
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#888",
                            fontSize: "14px",

                        }}
                    />

                    <Input
                        type="text"
                        placeholder="Search Party..."
                        value={searchParty}
                        onChange={(e) => setSearchParty(e.target.value.toLowerCase())}
                        style={{

                            borderRadius: "6px",
                            fontSize: "14px",
                        }}
                    />
                </div>


                <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto', paddingTop: '0' }}>
                    <Table className="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>Party Name</th>
                                <th style={{ width: 100, textAlign: 'center' }}>Select</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                partyGroupState
                                    .map((group) => {
                                        const filteredParties = group.parties.filter(p =>
                                            p.Name.toLowerCase().includes(searchParty)
                                        );

                                        if (filteredParties.length === 0) return null;

                                        return { ...group, parties: filteredParties };
                                    })
                                    .filter(Boolean)
                                    .map((group, idx) => (
                                        <React.Fragment key={idx}>

                                            {/* Group Header */}
                                            <tr style={{ backgroundColor: "#eef5ff" }}>
                                                <td style={{ fontWeight: "bold" }}>
                                                    {group.partyTypeName}
                                                </td>
                                                <td className="text-center">
                                                    <Input
                                                        type="checkbox"
                                                        checked={
                                                            group.parties.every(p =>
                                                                selectedParties.some(s => s.value === p.id)
                                                            )
                                                        }
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;

                                                            if (checked) {
                                                                const toAdd = group.parties.map(p => ({
                                                                    value: p.id,
                                                                    label: p.Name
                                                                }));

                                                                setSelectedParties(prev => {
                                                                    const existingIds = prev.map(x => x.value);
                                                                    const filtered = toAdd.filter(
                                                                        x => !existingIds.includes(x.value)
                                                                    );
                                                                    return [...prev, ...filtered];
                                                                });
                                                            } else {
                                                                setSelectedParties(prev =>
                                                                    prev.filter(
                                                                        x => !group.parties.some(p => p.id === x.value)
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </td>
                                            </tr>

                                            {/* Party Rows */}
                                            {group.parties.map((p) => {
                                                const checked = selectedParties.some(s => s.value === p.id);
                                                return (
                                                    <tr key={p.id}>
                                                        <td>{p.Name}{p.ShortName ? `(${p.ShortName})` : ""}</td>
                                                        <td className="text-center">
                                                            <Input
                                                                type="checkbox"
                                                                checked={checked}
                                                                onChange={() =>
                                                                    togglePartySelection({ value: p.id, label: p.Name })
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </React.Fragment>
                                    ))
                            }
                        </tbody>
                    </Table>
                </ModalBody>

                <ModalFooter></ModalFooter>
            </Modal>



        </div >
    );
};

export default ItemMasterForm;
